
		<div
			*ngIf="BOO_visible"
			class="dynamic-field form-group"
			[formGroup]="OBJ_form_group"
			[ngClass]="{'has-error': isInvalid()}">
			<label class="col-lg-2 control-label" [ngClass]="{'tgi-new': isNew()}">{{getLabelName()|translate}}
                <span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
			<div class="col-lg-8">
				<select class="form-control"
					[formControlName]="OBJ_field_config.name"
					(change)="setValue($event.target.value)">
				  <option value="">{{"please_select"|translate}}</option>
				  <option *ngFor="let OBJ_option of OBJ_field_config.options"
					  value="{{OBJ_option.id}}"
					  [disabled]="OBJ_option?.deprecated"
					  [ngClass]="{'tig-deprecated': OBJ_option?.deprecated}">
					  {{getLabelNameOption(OBJ_option)|translate}}
					  <ng-container *ngIf="OBJ_option?.deprecated">
						   - {{'deprecated'|translate}}
					  </ng-container>
				  </option>
				</select>
				<div class="tig-hint" *ngIf="OBJ_field_config.dependent_fields">
					<span *ngIf="BOO_one_dependent_field">{{ "oSelect.sWarningDependentField"|translate:{value:this.STR_dependent_fields} }}</span>
					<span *ngIf="!BOO_one_dependent_field">{{ "oSelect.sWarningDependentFields"|translate:{value:this.STR_dependent_fields} }}</span>
				</div>
				<div class="tig-hint" *ngIf="OBJ_field_config.note">
					<span>{{ OBJ_field_config.note|translate}}</span>
				</div>
                <tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
			</div>
		</div>
	